import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// import { Role } from '../__generated__/graphql.js';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export enum TemperatureUnit {
  Celsius = 'Celsius',
  Fahrenheit = 'Fahrenheit',
}

export function formatCelsiusTemperature(temperatureCelsius: string, unit: TemperatureUnit): string {
  switch (unit) {
    case TemperatureUnit.Celsius:
      return `${Math.round(Number(temperatureCelsius))}°C`;
    case TemperatureUnit.Fahrenheit:
      return `${Math.round(Number(temperatureCelsius) * 1.8 + 32)}°F`;
  }
}

export const toKebabCase = (str: string): string => {
  const words = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);

  if (!words) {
    return str;
  }
  return words.map((word) => word.toLowerCase()).join('-');
};
